import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box } from 'grid-styled'
import classNames from 'classnames'
import styles from './Level2.module.scss'
import More from '../More'
import Outline from '../Outline'
import Loading from '../Loading'
import Table from '../Table'
import TableFooter from '../TableFooter'
import ExternalLink from '../ExternalLink'

const askColumns = [{
  name: 'mmId',
  header: 'MPID',
  tooltip: ({ mmIdDisplay }) => ({ text: mmIdDisplay })
}, {
  name: 'priceDisplay',
  header: 'Ask Price',
  align: 'right'
}, {
  name: 'size',
  header: 'Size',
  type: 'int'
}, {
  name: 'transTimeDisplay',
  header: 'Time',
  align: 'right'
}]

const bidColumns = [{
  name: 'mmId',
  header: 'MPID',
  tooltip: ({ mmIdDisplay }) => ({ text: mmIdDisplay })
}, {
  name: 'priceDisplay',
  header: 'Bid Price',
  align: 'right'
}, {
  name: 'size',
  header: 'Size',
  type: 'int'
}, {
  name: 'transTimeDisplay',
  header: 'Time',
  align: 'right'
}]

class Level2 extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {
      selectedTable: 'BID'
    }
  }

  onTableSwitch = (mode) => {
    return () => {
      this.setState({ selectedTable: mode })
    }
  }

  render () {
    const { loaded, data, accent, onExpand, expandDisabled, showFootnote } = this.props
    return <div id='level-2' className={styles.montage}>
      <Outline mode='heading' accent={accent}>Real-Time Level 2 Quote</Outline>
      <Loading
        type='table'
        loaded={loaded}>
        <Flex w={1}>
          <Box w={5.75 / 12} className={classNames({
            [styles.tableSwitch]: true,
            [styles.active]: this.state.selectedTable === 'BID'
          })} onClick={this.onTableSwitch('BID')}>
            Bid
          </Box>
          <Box w={0.5 / 12} />
          <Box w={5.75 / 12} className={classNames({
            [styles.tableSwitch]: true,
            [styles.active]: this.state.selectedTable === 'ASK'
          })} onClick={this.onTableSwitch('ASK')}>
            Ask
          </Box>
        </Flex>
        <Flex wrap w={1}>
          <Box
            w={[1, 5.75 / 12, 5.75 / 12]}
            className={classNames({
              [styles.tableHidden]: this.state.selectedTable !== 'BID'
            })}>
            <Table
              columns={bidColumns}
              data={data.montageBuyList}
              showHeader
            />
          </Box>
          <Box w={[0, 0.5 / 12, 0.5 / 12]} />
          <Box
            w={[1, 5.75 / 12, 5.75 / 12]}
            className={classNames({
              [styles.tableHidden]: this.state.selectedTable !== 'ASK'
            })}>
            <Table
              columns={askColumns}
              data={data.montageSellList}
              showHeader
            />
          </Box>
        </Flex>
        {!expandDisabled && <TableFooter>
          <More onClick={onExpand} />
        </TableFooter>}
      </Loading>
      {showFootnote && <div className={styles.footerNote}>
        <b>Level 2 Quote Key: </b>
        MPID - Market Participant ID | cMPID - Closed Quote | MPIDu - Unsolicited Quote | U - Unpriced Quote.  All Prices are in USD.
        <br />
        <br />
      Level 2 Quotes include quotes from the <ExternalLink href='https://www.otcmarkets.com/otc-link/otc-link-services'>OTC Link NQB</ExternalLink> (&quot;OTCN&quot;) alternative trading system.  OTCN quotes represent consolidated broker-dealer quotes at distinct price points, and are included here to provide additional transparency into available liquidity.  OTCN does not act as a market maker, hold positions, or engage in proprietary trading.
      </div>}
    </div>
  }
}

Level2.propTypes = {
  loaded: PropTypes.bool,
  data: PropTypes.object,
  accent: PropTypes.string,
  onExpand: PropTypes.func,
  expandDisabled: PropTypes.bool,
  showFootnote: PropTypes.bool
}

export default Level2
